import React from "react";

const UsersTableEmptyMessage = () => {
    return (
        <div>
            No users have been added yet. Select <b>New User</b> to create the user.
        </div>
    );
};

export default UsersTableEmptyMessage;